import gql from 'graphql-tag';

export default gql`
  mutation markNotificationRead(
    $xuid: String!
  ) {
    markNotificationRead(
      xuid: $xuid
    ) {
      xuid
    }
  }
`;
